
// capitalize the first letter of a string
export const capitalizeFirstLetter = (str) => {
  if (!str) return ''; // check for undefined or empty strings
  return str.charAt(0).toUpperCase() + str.slice(1);
};
